import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import OmniAIPage from "../pages/omni-ai/page";
import RWAPage from "../pages/rwa-tokenization/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/products/omni-ai",
    element: <OmniAIPage />,
  },
  {
    path: "/products/rwa-tokenization",
    element: <RWAPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
